export const ERROR_READY_ANSWERED = 400860001;
export const ERROR_REMAINING_ZERO = 400850010;
export const ERROR_NOT_IN_PROGRESS = 400850003;
export const ERROR_ADMISSION_NOT_FOUND = 400850002;
export const ERROR_ADMISSION_STARTED = 400850008;